/* @generated */
// prettier-ignore
if (Intl.RelativeTimeFormat && typeof Intl.RelativeTimeFormat.__addLocaleData === 'function') {
  Intl.RelativeTimeFormat.__addLocaleData({
    "data": {
      "day": {
        "-1": "ଗତକାଲି",
        "0": "ଆଜି",
        "1": "ଆସନ୍ତାକାଲି",
        "future": {
          "one": "{0} ଦିନରେ",
          "other": "{0} ଦିନରେ"
        },
        "past": {
          "one": "{0} ଦିନ ପୂର୍ବେ",
          "other": "{0} ଦିନ ପୂର୍ବେ"
        }
      },
      "day-narrow": {
        "-1": "ଗତକାଲି",
        "0": "ଆଜି",
        "1": "ଆସନ୍ତାକାଲି",
        "future": {
          "one": "{0} ଦିନରେ",
          "other": "{0} ଦିନରେ"
        },
        "past": {
          "one": "{0} ଦିନ ପୂର୍ବେ",
          "other": "{0} ଦିନ ପୂର୍ବେ"
        }
      },
      "day-short": {
        "-1": "ଗତକାଲି",
        "0": "ଆଜି",
        "1": "ଆସନ୍ତାକାଲି",
        "future": {
          "one": "{0} ଦିନରେ",
          "other": "{0} ଦିନରେ"
        },
        "past": {
          "one": "{0} ଦିନ ପୂର୍ବେ",
          "other": "{0} ଦିନ ପୂର୍ବେ"
        }
      },
      "hour": {
        "0": "ଏହି ଘଣ୍ଟା",
        "future": {
          "one": "{0} ଘଣ୍ଟାରେ",
          "other": "{0} ଘଣ୍ଟାରେ"
        },
        "past": {
          "one": "{0} ଘଣ୍ଟା ପୂର୍ବେ",
          "other": "{0} ଘଣ୍ଟା ପୂର୍ବେ"
        }
      },
      "hour-narrow": {
        "0": "ଏହି ଘଣ୍ଟା",
        "future": {
          "one": "{0} ଘ. ରେ",
          "other": "{0} ଘ. ରେ"
        },
        "past": {
          "one": "{0} ଘ. ପୂର୍ବେ",
          "other": "{0} ଘ. ପୂର୍ବେ"
        }
      },
      "hour-short": {
        "0": "ଏହି ଘଣ୍ଟା",
        "future": {
          "one": "{0} ଘ. ରେ",
          "other": "{0} ଘ. ରେ"
        },
        "past": {
          "one": "{0} ଘ. ପୂର୍ବେ",
          "other": "{0} ଘ. ପୂର୍ବେ"
        }
      },
      "minute": {
        "0": "ଏହି ମିନିଟ୍",
        "future": {
          "one": "{0} ମିନିଟ୍‌‌ରେ",
          "other": "{0} ମିନିଟ୍‌‌ରେ"
        },
        "past": {
          "one": "{0} ମିନିଟ୍ ପୂର୍ବେ",
          "other": "{0} ମିନିଟ୍ ପୂର୍ବେ"
        }
      },
      "minute-narrow": {
        "0": "ଏହି ମିନିଟ୍",
        "future": {
          "one": "{0} ମି. ରେ",
          "other": "{0} ମି. ରେ"
        },
        "past": {
          "one": "{0} ମି. ପୂର୍ବେ",
          "other": "{0} ମି. ପୂର୍ବେ"
        }
      },
      "minute-short": {
        "0": "ଏହି ମିନିଟ୍",
        "future": {
          "one": "{0} ମି. ରେ",
          "other": "{0} ମି. ରେ"
        },
        "past": {
          "one": "{0} ମି. ପୂର୍ବେ",
          "other": "{0} ମି. ପୂର୍ବେ"
        }
      },
      "month": {
        "-1": "ଗତ ମାସ",
        "0": "ଏହି ମାସ",
        "1": "ଆଗାମୀ ମାସ",
        "future": {
          "one": "{0} ମାସରେ",
          "other": "{0} ମାସରେ"
        },
        "past": {
          "one": "{0} ମାସ ପୂର୍ବେ",
          "other": "{0} ମାସ ପୂର୍ବେ"
        }
      },
      "month-narrow": {
        "-1": "ଗତ ମାସ",
        "0": "ଏହି ମାସ",
        "1": "ଆଗାମୀ ମାସ",
        "future": {
          "one": "{0} ମା. ରେ",
          "other": "{0} ମା. ରେ"
        },
        "past": {
          "one": "{0} ମା. ପୂର୍ବେ",
          "other": "{0} ମା. ପୂର୍ବେ"
        }
      },
      "month-short": {
        "-1": "ଗତ ମାସ",
        "0": "ଏହି ମାସ",
        "1": "ଆଗାମୀ ମାସ",
        "future": {
          "one": "{0} ମା. ରେ",
          "other": "{0} ମା. ରେ"
        },
        "past": {
          "one": "{0} ମା. ପୂର୍ବେ",
          "other": "{0} ମା. ପୂର୍ବେ"
        }
      },
      "nu": ["latn"],
      "quarter": {
        "-1": "ଗତ ତ୍ରୟମାସ",
        "0": "ଗତ ତ୍ରୟମାସ",
        "1": "ଆଗାମୀ ତ୍ରୟମାସ",
        "future": {
          "one": "{0} ତ୍ରୟମାସରେ",
          "other": "{0} ତ୍ରୟମାସରେ"
        },
        "past": {
          "one": "{0} ତ୍ରୟମାସ ପୂର୍ବେ",
          "other": "{0} ତ୍ରୟମାସ ପୂର୍ବେ"
        }
      },
      "quarter-narrow": {
        "-1": "ଗତ ତିନିମାସ",
        "0": "ଏହି ତିନିମାସ",
        "1": "ଆଗାମୀ ତିନିମାସ",
        "future": {
          "one": "{0} ତ୍ରୟ. ରେ",
          "other": "{0} ତ୍ରୟ. ରେ"
        },
        "past": {
          "one": "{0} ତ୍ରୟ. ପୂର୍ବେ",
          "other": "{0} ତ୍ରୟ. ପୂର୍ବେ"
        }
      },
      "quarter-short": {
        "-1": "ଗତ ତିନିମାସ",
        "0": "ଏହି ତ୍ରୟମାସ",
        "1": "ଆଗାମୀ ତ୍ରୟମାସ",
        "future": {
          "one": "{0} ତ୍ରୟ. ରେ",
          "other": "{0} ତ୍ରୟ. ରେ"
        },
        "past": {
          "one": "{0} ତ୍ରୟ. ପୂର୍ବେ",
          "other": "{0} ତ୍ରୟ. ପୂର୍ବେ"
        }
      },
      "second": {
        "0": "ବର୍ତ୍ତମାନ",
        "future": {
          "one": "{0} ସେକେଣ୍ଡରେ",
          "other": "{0} ସେକେଣ୍ଡରେ"
        },
        "past": {
          "one": "{0} ସେକେଣ୍ଡ ପୂର୍ବେ",
          "other": "{0} ସେକେଣ୍ଡ ପୂର୍ବେ"
        }
      },
      "second-narrow": {
        "0": "ବର୍ତ୍ତମାନ",
        "future": {
          "one": "{0} ସେ. ରେ",
          "other": "{0} ସେ. ରେ"
        },
        "past": {
          "one": "{0} ସେ. ପୂର୍ବେ",
          "other": "{0} ସେ. ପୂର୍ବେ"
        }
      },
      "second-short": {
        "0": "ବର୍ତ୍ତମାନ",
        "future": {
          "one": "{0} ସେ. ରେ",
          "other": "{0} ସେ. ରେ"
        },
        "past": {
          "one": "{0} ସେ. ପୂର୍ବେ",
          "other": "{0} ସେ. ପୂର୍ବେ"
        }
      },
      "week": {
        "-1": "ଗତ ସପ୍ତାହ",
        "0": "ଏହି ସପ୍ତାହ",
        "1": "ଆଗାମୀ ସପ୍ତାହ",
        "future": {
          "one": "{0} ସପ୍ତାହରେ",
          "other": "{0} ସପ୍ତାହରେ"
        },
        "past": {
          "one": "{0} ସପ୍ତାହ ପୂର୍ବେ",
          "other": "{0} ସପ୍ତାହ ପୂର୍ବେ"
        }
      },
      "week-narrow": {
        "-1": "ଗତ ସପ୍ତାହ",
        "0": "ଏହି ସପ୍ତାହ",
        "1": "ଆଗାମୀ ସପ୍ତାହ",
        "future": {
          "one": "{0} ସପ୍ତା. ରେ",
          "other": "{0} ସପ୍ତା. ରେ"
        },
        "past": {
          "one": "{0} ସପ୍ତା. ପୂର୍ବେ",
          "other": "{0} ସପ୍ତା. ପୂର୍ବେ"
        }
      },
      "week-short": {
        "-1": "ଗତ ସପ୍ତାହ",
        "0": "ଏହି ସପ୍ତାହ",
        "1": "ଆଗାମୀ ସପ୍ତାହ",
        "future": {
          "one": "{0} ସପ୍ତା. ରେ",
          "other": "{0} ସପ୍ତା. ରେ"
        },
        "past": {
          "one": "{0} ସପ୍ତା. ପୂର୍ବେ",
          "other": "{0} ସପ୍ତା. ପୂର୍ବେ"
        }
      },
      "year": {
        "-1": "ଗତ ବର୍ଷ",
        "0": "ଏହି ବର୍ଷ",
        "1": "ଆଗାମୀ ବର୍ଷ",
        "future": {
          "one": "{0} ବର୍ଷରେ",
          "other": "{0} ବର୍ଷରେ"
        },
        "past": {
          "one": "{0} ବର୍ଷ ପୂର୍ବେ",
          "other": "{0} ବର୍ଷ ପୂର୍ବେ"
        }
      },
      "year-narrow": {
        "-1": "ଗତ ବର୍ଷ",
        "0": "ଏହି ବର୍ଷ",
        "1": "ଆଗାମୀ ବର୍ଷ",
        "future": {
          "one": "{0} ବ. ରେ",
          "other": "{0} ବ. ରେ"
        },
        "past": {
          "one": "{0} ବ. ପୂର୍ବେ",
          "other": "{0} ବ. ପୂର୍ବେ"
        }
      },
      "year-short": {
        "-1": "ଗତ ବର୍ଷ",
        "0": "ଏହି ବର୍ଷ",
        "1": "ଆଗାମୀ ବର୍ଷ",
        "future": {
          "one": "{0} ବ. ରେ",
          "other": "{0} ବ. ରେ"
        },
        "past": {
          "one": "{0} ବ. ପୂର୍ବେ",
          "other": "{0} ବ. ପୂର୍ବେ"
        }
      }
    },
    "locale": "or"
  });
}